import { Fragment, useRef, useState } from "react";
import { CheckLg } from "react-bootstrap-icons";
import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { saveSystemSettings } from "../../store/api/SystemSettingsAPI";

const InvoiceSettings = (props) => {
    const settingValues = useRef({});
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);
    const { findCheckedSetting, findSetting } = props;
    const save = () => {
        setPending(true);
        dispatch(saveSystemSettings(settingValues.current, () => { setPending(false) }));
    }
    return (
        <Fragment>
            <div className="row" style={{ fontSize: "12px" }}>
                <div className="form-group col-md-3">
                    <label>پیش فرض نحوه تسویه فاکتور فروش</label>
                    <select name="DefaultSettleSalesInvoice" onChange={e => settingValues.current.DefaultSettleSalesInvoice = e.target.value} defaultValue={findSetting("DefaultSettleSalesInvoice")} className="form-control">
                        <option value="0">تسویه نشد</option>
                        <option value="1">تسویه نقد</option>
                        <option value="2">چک و نقد</option>
                    </select>
                </div>
                <div className="form-group col-md-3">
                    <label>ارزش گذاری انبار</label>
                    <select onChange={e => settingValues.current.StgValuationType = e.target.value} defaultValue={findSetting("StgValuationType")} className="form-control">
                        <option value="0">میانگین موزون</option>
                        <option value="1">FIFO</option>
                        <option value="2">LIFO</option>
                    </select>
                </div>
                <div className="form-group col-md-3">
                    <label>قیمت پیش فرض کالا در انتخاب کالای فاکتورها</label>
                    <select onChange={e => settingValues.current.ProductDefaultSalePrice = e.target.value} defaultValue={findSetting("ProductDefaultSalePrice")} className="form-control">
                    <option value="MeanAvgPrice">میانگین موزون</option>
                        <option value="SalePrice">قیمت فروش</option>
                        <option value="GauranteeSalePrice">قیمت فروش گارانتی</option>
                        <option value="SalePrice3">قیمت فروش سوم</option>
                        <option value="LastSalePrice">قیمت آخرین فروش</option>
                    </select>
                </div>   
                <div className="form-group col-md-3">
                    <label>عنوان قیمت پیش فرض کالا در انتخاب کالای فاکتورها</label>
                    <input type="text" onChange={e => settingValues.current.ProductDefaultSalePriceLabel = e.target.value} defaultValue={findSetting("ProductDefaultSalePriceLabel")} className="form-control"/>
                </div>                             
            </div>
            <div className="row mt-2" style={{ fontSize: "12px" }}>
                <div className="form-group col-md-3">
                    <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("AllowNegativeProductCount")}
                        onChange={e => settingValues.current.AllowNegativeProductCount = e.target.checked} id="chkAllowNegativeProductCount"/>&nbsp;
                    <span>امکان منفی شدن موجودی کالا حین صدور فاکتور</span>
                </div>
                <div className="form-group col-md-3">
                    <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("ApproveInvoiceAfterInsert")}
                        onChange={e => settingValues.current.ApproveInvoiceAfterInsert = e.target.checked} />&nbsp;
                    <span>تایید خودکار فاکتورها پس از صدور</span>
                </div>
                <div className="form-group col-md-3">
                    <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("AccountingSystem_SetInvoiceAccountingDocumentToInvoiceDate")}
                        onChange={e => settingValues.current.AccountingSystem_SetInvoiceAccountingDocumentToInvoiceDate = e.target.checked} />&nbsp;
                    <span>اسناد حسابداری فاکتورها به جای تاریخ ثبت، به تاریخ فاکتور تنظیم شود</span>
                </div>
                <div className="form-group col-md-3">
                    <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("GuaranteeCheck_InvoiceCreateMonitorsSerials")}
                        onChange={e => settingValues.current.GuaranteeCheck_InvoiceCreateMonitorsSerials = e.target.checked} />&nbsp;
                    <span>فاکتورهای انبار حین صدور، باعث ورود و خروج سریالها در انبارها شود</span>
                </div>
                <div className="form-group col-md-3">
                    <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("GuaranteeCheck_InvoiceCreateSerialsHistory")}
                        onChange={e => settingValues.current.GuaranteeCheck_InvoiceCreateSerialsHistory = e.target.checked} />&nbsp;
                    <span>فاکتورهای انبار حین صدور، تاریخچه انبار را ثبت کنند</span>
                </div>
                <div className="form-group col-md-3">
                    <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("AllowNegativeProductCount")}
                        onChange={e => settingValues.current.AllowNegativeProductCount = e.target.checked} />&nbsp;
                    <span> حین صدور فاکتور، در ستون تعداد به جای عدد یک مقدار پیشنهادی سیستم قرار گیرد</span>
                </div>

            </div>
            <button className="mt-2 btn btn-success group-Btn" onClick={save} disabled={pending}><CheckLg size={12} />&nbsp;ذخیره تغییرات</button>
        </Fragment>
    )
}
export default InvoiceSettings;